{
  "ar-SA": 86,
  "az-AZ": 23,
  "bg-BG": 61,
  "bn-BD": 37,
  "bn-IN": 37,
  "ca-ES": 79,
  "cs-CZ": 72,
  "da-DK": 27,
  "de-CH": 96,
  "de-DE": 96,
  "el-GR": 75,
  "en": 100,
  "es-ES": 96,
  "eu-ES": 96,
  "fa-IR": 80,
  "fi-FI": 58,
  "fr-FR": 98,
  "gl-ES": 59,
  "he-IL": 99,
  "hi-IN": 81,
  "hu-HU": 63,
  "id-ID": 99,
  "it-IT": 99,
  "ja-JP": 94,
  "kaa": 20,
  "kab-KAB": 53,
  "kk-KZ": 12,
  "km-KH": 53,
  "ko-KR": 85,
  "ku-TR": 56,
  "lt-LT": 32,
  "lv-LV": 49,
  "mr-IN": 79,
  "my-MM": 23,
  "nb-NO": 79,
  "nl-NL": 96,
  "nn-NO": 42,
  "oc-FR": 74,
  "pa-IN": 51,
  "pl-PL": 87,
  "pt-BR": 96,
  "pt-PT": 96,
  "ro-RO": 100,
  "ru-RU": 96,
  "si-LK": 65,
  "sk-SK": 96,
  "sl-SI": 79,
  "sv-SE": 96,
  "ta-IN": 76,
  "th-TH": 63,
  "tr-TR": 95,
  "uk-UA": 90,
  "uz-UZ": 0,
  "vi-VN": 66,
  "zh-CN": 96,
  "zh-HK": 15,
  "zh-TW": 99
}
